import { createFileRoute } from '@tanstack/react-router'
import { ChangelogPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/changelog/')({
  loader: () => loadPageData({ data: { kind: 'changelog', locale: 'it' } }),
  head: () => staticRouteHead('changelog', 'it'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <ChangelogPage />
    </CatalogProvider>
  )
}
